module.exports = __webpack_public_path__ + "img/jujialei-3.373424a4.png";